import 'css-chunksrc/client/scenes/project/secondaryCriteria/activityMonitoringSection/styles.scss';export default {
  "sectionContainer": "_sectionContainer_1frfi_1",
  "sectionRow": "_sectionRow_1frfi_9",
  "sectionLabel": "_sectionLabel_1frfi_30",
  "sectionValue": "_sectionValue_1frfi_40",
  "text": "_text_1frfi_49",
  "positive": "_positive_1frfi_54",
  "warning": "_warning_1frfi_58"
};